module.exports = __webpack_public_path__ + "img/20.b12be17b.jpg";